<div class="container container__notify-background desktop-notification">
    <div class="container__notify-background" fxLayout="row" fxLayout.lt-sm="column"
         fxLayoutAlign="center center"
         fxLayoutGap="20px">
        <div class="container__notify-background--logo" fxFlex="33" *ngIf="imageVisible">
            <img class="travel-img" [src]="backgroundLogo">
        </div>

        <div class="container__notify-background--description"
             fxFlex="66"
             fxLayout="column"
             fxLayoutAlign="center center"
             fxLayoutAlign.gt-sm="start start">
            <div class="message text-center">
                <h2 class="message message--title"> {{ 'POSITIVE_NOTIFICATION_COMPONENT.header' | translate }} </h2>
                <p class="message message--description" [innerHTML]="notificationState.message | safeHtml"></p>
                <p *ngIf="canShowMpayMessage" class="message message--description">{{ 'POSITIVE_NOTIFICATION_COMPONENT.mPayMessage' | translate }}</p>
            </div>
        </div>
    </div>
</div>
